import { ApiService } from 'src/app/api.service';
import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ResizeService } from '../../services/resize.service';
@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent {
  @Input() listProducts: any = [];
  breadcrumbData = {};
  scrollPosition: number = 0;
  constructor(
    private apiSevice : ApiService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private resizeService: ResizeService,
    private elementRef: ElementRef,
    private router: Router    ) {}

    @HostListener('window:scroll', ['$event'])
    updateScrollPosition(event: any) {
      this.scrollPosition = window.scrollY;
    }

  ngOnInit(){
    const savedScrollPosition = localStorage.getItem('scrollPosition');

    this.listProducts.map(async (i:any) => {
      if(i.IMGPR1){
        i.resizedImageUrl = await this.resizeService.getUrlResized(i.IMGPR1);
      }
    })

    if (savedScrollPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScrollPosition));
        localStorage.removeItem('scrollPosition');
       }, 0);
    }
  }

  async getActualRoute(){
    let category = await this.apiSevice.getCategoryByIdSlug(this.activatedRoute.snapshot.paramMap.get('categorySlug')).then((e: any) => e);
    let subcategory = await this.apiSevice.getCategoryByIdSlug(this.activatedRoute.snapshot.paramMap.get('subcategorySlug')).then((e: any) => e);
    let subsubcategory;
    if(this.activatedRoute.snapshot.paramMap.get('subsubcategorySlug')){
      subsubcategory = await this.apiSevice.getCategoryByIdSlug(this.activatedRoute.snapshot.paramMap.get('subsubcategorySlug')).then((e: any) => e);
    }

    this.breadcrumbData = {
      category: {name: category.nome, link: `linhas/${category.slug}`},
      subcategory: {name: subcategory.nome, link: `linhas/${category.slug}/${subcategory.slug}`},
      subsubcategory: subsubcategory ? {name: subsubcategory.nome, link: `linhas/${category.slug}/${subcategory.slug}/${subsubcategory.slug}`} : null
    }
  }

async goToProductDetail(param: string) {
  localStorage.setItem('scrollPosition', this.scrollPosition.toString());
  await this.getActualRoute();

  this.route.navigate([`produto-detalhe/${param}`], {state: {data: this.breadcrumbData}} );

  }
}

